import { Booking, BookingStatus, Device } from '@pages/booking/types';
import { FC } from 'react';
import Credentials from './Credentials';

interface BookingCredentialsProps {
    selectedDevice: Device;
    bookingForItem: Booking;
}

const BookingCredentials: FC<BookingCredentialsProps> = ({ selectedDevice, bookingForItem }) => {
    if (bookingForItem.status !== BookingStatus.IN_PROGRESS) {
        return null;
    }

    return <Credentials device={selectedDevice} credentialsObject={bookingForItem} />;
};

export default BookingCredentials;
